module.exports = __webpack_public_path__ + "media/images/chocolate-toxic-calculator.png";